import { css } from '@emotion/react';
import { IonCol, IonGrid, IonRow, IonText } from '@ionic/react';
import React from 'react';
import { useLocation } from '../../contexts/LocationContext';
import * as commonCss from '../../styles/common';
import { Point } from '../../types';
import ImgFallback from '../ImgFallback';
import { SkeletonText } from '../SkeletonText';

interface GeolocationInfoProps {
  location: Point;
}

export const GeolocationInfo: React.FC<GeolocationInfoProps> = ({ location }) => {
  const [siteImageUrl, setSiteImageUrl] = React.useState<string | null>(null);
  const [siteAddress, setSiteAddress] = React.useState<string | null>(null);
  const { reverseLookupLocation, getStreetViewImageUrl } = useLocation();

  const geolocationInfoCss = React.useMemo(() => {
    return {
      container: [commonCss.centered, commonCss.noPadding],
      siteAddress: [commonCss.smallText, commonCss.italics],
      siteImageContainer: [
        commonCss.noPadding,
        commonCss.roundedCorners,
        css({
          overflow: 'hidden',
        }),
      ],
    };
  }, []);

  React.useEffect(() => {
    const fetchData = async () => {
      setSiteAddress(null);
      setSiteImageUrl(null);
      const result = await reverseLookupLocation(location, 'street_address');
      setSiteAddress(result?.displayName ?? 'Address not available');
      const imageUrl = getStreetViewImageUrl(location);
      setSiteImageUrl(imageUrl);
    };
    fetchData();
  }, [location]);
  return (
    <IonGrid css={geolocationInfoCss.container}>
      <IonRow>
        <IonCol>
          {siteAddress ? <IonText css={geolocationInfoCss.siteAddress}>{siteAddress}</IonText> : <SkeletonText />}
        </IonCol>
      </IonRow>
      <IonRow>
        <IonCol css={geolocationInfoCss.siteImageContainer} key={siteImageUrl}>
          <ImgFallback src={siteImageUrl ?? undefined} alt="Site Image" />
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};
